import api from './api';

// ============================================================
// Service do Dashboard Preditivo (T2 / Camada 2).
// Espelha back/controller/dashboard/Controller.DashboardPreditivo.pas:
//   GET    /v1/dashboard-preditivo              -> todas as métricas
//   GET    /v1/dashboard-preditivo/:tipo        -> 1 métrica
//   POST   /v1/dashboard-preditivo/recalcular   -> força ciclo
//   GET    /v1/dashboard-preditivo/engine/status
// ============================================================

const BASE = '/v1/dashboard-preditivo';

export const obterTudo = async () => {
  const { data } = await api.get(BASE);
  return data;
};

export const obterMetrica = async (tipo) => {
  const { data } = await api.get(`${BASE}/${tipo}`);
  return data;
};

export const recalcular = async () => {
  const { data } = await api.post(`${BASE}/recalcular`);
  return data;
};

export const obterEngineStatus = async () => {
  const { data } = await api.get(`${BASE}/engine/status`);
  return data;
};

export const obterConfig = async () => {
  const { data } = await api.get(`${BASE}/config`);
  return data;
};

export const atualizarConfig = async (payload) => {
  const { data } = await api.put(`${BASE}/config`, payload);
  return data;
};

const dashboardPreditivoService = {
  obterTudo,
  obterMetrica,
  recalcular,
  obterEngineStatus,
  obterConfig,
  atualizarConfig,
};

export default dashboardPreditivoService;
